module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-root"
  }, [_c('div', {
    staticClass: "list-box"
  }, _vm._l((_vm.lists), function(ref) {
    var title = ref.title;
    var content = ref.content;

    return _c('div', {
      staticClass: "list"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(title))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('p', [_vm._v(_vm._s(content))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f36f8fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/collections/lists.vue
// module id = 196
// module chunks = 0